// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Recharts = require("recharts");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Querystringify = require("querystringify");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var User$ReactHooksTemplate = require("./user.res.js");
var Recharts$ReactHooksTemplate = require("../dashboard/common/Recharts.res.js");
var Pagination$ReactHooksTemplate = require("../common/Pagination.res.js");
var AuthProvider$ReactHooksTemplate = require("../AuthProvider.res.js");
var UserListItem$ReactHooksTemplate = require("./UserListItem.res.js");
var PaginationUtils$ReactHooksTemplate = require("../common/PaginationUtils.res.js");
var ConfirmationDialog$ReactHooksTemplate = require("./ConfirmationDialog.res.js");

function deleteUser(user) {
  var userId = String(User$ReactHooksTemplate.id(user));
  return Http$ReactHooksTemplate.fetchPostJSON("/api/v1/users/" + userId + "/delete", {});
}

function reducer(state, action) {
  if (typeof action !== "object") {
    switch (action) {
      case "LoadUsers" :
          return {
                  users: state.users,
                  userToDelete: state.userToDelete,
                  statusCount: state.statusCount,
                  loadingUsers: true,
                  loadingStatusCount: state.loadingStatusCount
                };
      case "LoadStatusCount" :
          return {
                  users: state.users,
                  userToDelete: state.userToDelete,
                  statusCount: state.statusCount,
                  loadingUsers: state.loadingUsers,
                  loadingStatusCount: true
                };
      case "CancelDelete" :
          return {
                  users: state.users,
                  userToDelete: undefined,
                  statusCount: state.statusCount,
                  loadingUsers: state.loadingUsers,
                  loadingStatusCount: state.loadingStatusCount
                };
      
    }
  } else {
    switch (action.TAG) {
      case "DisplayList" :
          return {
                  users: action._0,
                  userToDelete: state.userToDelete,
                  statusCount: state.statusCount,
                  loadingUsers: false,
                  loadingStatusCount: state.loadingStatusCount
                };
      case "DisplayStatusCount" :
          return {
                  users: state.users,
                  userToDelete: state.userToDelete,
                  statusCount: action._0,
                  loadingUsers: state.loadingUsers,
                  loadingStatusCount: false
                };
      case "DisplayDeleteConfirmation" :
          return {
                  users: state.users,
                  userToDelete: action._0,
                  statusCount: state.statusCount,
                  loadingUsers: state.loadingUsers,
                  loadingStatusCount: state.loadingStatusCount
                };
      
    }
  }
}

function totalRecord(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "1";
  }
}

function perPage(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "1";
  }
}

var initialState = {
  users: /* [] */0,
  userToDelete: undefined,
  statusCount: {
    active: 0,
    inActive: 0
  },
  loadingUsers: true,
  loadingStatusCount: true
};

var searchPlaceholder = "Search Users";

function UserList(props) {
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  var match$1 = React.useState(function (param) {
        
      });
  var setSearchKey = match$1[1];
  var searchKey = match$1[0];
  var match$2 = React.useState(function (param) {
        return false;
      });
  var setDeletingUser = match$2[1];
  var queryParams = Querystringify.parse(props.search);
  var x = Js_dict.get(queryParams, "page");
  var currentPage;
  if (x !== undefined && x !== "") {
    var page = Belt_Int.fromString(x);
    currentPage = page !== undefined ? page : 1;
  } else {
    currentPage = 1;
  }
  var x$1 = Js_dict.get(queryParams, "search");
  var currentSearchKey = x$1 !== undefined && x$1 !== "" ? x$1 : undefined;
  var match$3 = React.useState(function (param) {
        return {
                total: "1",
                perPage: "1",
                currentPage: currentPage
              };
      });
  var setPageInfo = match$3[1];
  var pageInfo = match$3[0];
  var fetchUsers = function (param) {
    var pageNumber = String(pageInfo.currentPage);
    var url = currentSearchKey !== undefined ? "/api/v1/users?page=" + pageNumber + "&search=" + currentSearchKey : "/api/v1/users?page=" + pageNumber;
    return Js_promise.then_((function (param) {
                  var headers = param[0];
                  var x = headers.get("Total");
                  var total = x !== null ? (
                      x === null ? undefined : Caml_option.some(x)
                    ) : "1";
                  var x$1 = headers.get("Per-Page");
                  var perPage = x$1 !== null ? (
                      x$1 === null ? undefined : Caml_option.some(x$1)
                    ) : "1";
                  var users = Js_promise.then_((function (json) {
                          return Promise.resolve(Json_decode.field("users", (function (param) {
                                            return Json_decode.list(User$ReactHooksTemplate.decode, param);
                                          }), json));
                        }), param[1]);
                  Curry._1(setSearchKey, (function (param) {
                          return currentSearchKey;
                        }));
                  return Promise.resolve([
                              users,
                              [
                                total,
                                perPage
                              ]
                            ]);
                }), Http$ReactHooksTemplate.fetchGetJSONWithHeader(url));
  };
  var match$4 = React.useContext(AuthProvider$ReactHooksTemplate.authContext);
  var hasPermission = match$4[0];
  var totalCount = Caml_format.int_of_string(pageInfo.total);
  var perPageCount = Caml_format.int_of_string(pageInfo.perPage);
  var totalPagesCount = PaginationUtils$ReactHooksTemplate.totalPages(totalCount, perPageCount);
  var handlePageChange = function (pageNumber) {
    var pageNumber$1 = String(pageNumber);
    if (searchKey !== undefined) {
      RescriptReactRouter.push("/users/all?page=" + pageNumber$1 + "&search=" + searchKey);
    } else {
      RescriptReactRouter.push("/users/all?page=" + pageNumber$1);
    }
    Curry._1(setPageInfo, (function (pageInfo) {
            return {
                    total: pageInfo.total,
                    perPage: pageInfo.perPage,
                    currentPage: Caml_format.int_of_string(pageNumber$1)
                  };
          }));
    window.scrollTo(0.0, 0.0);
  };
  React.useEffect((function (param) {
          Curry._1(dispatch, "LoadStatusCount");
          var url = currentSearchKey !== undefined ? "/api/v1/users/status_wise_count?search=" + currentSearchKey : "/api/v1/users/status_wise_count";
          Js_promise.then_((function (json) {
                  var statusCount_active = Belt_Option.getWithDefault(Json_decode.field("count", (function (param) {
                              return Json_decode.optional((function (param) {
                                            return Json_decode.field("true", Json_decode.$$int, param);
                                          }), param);
                            }), json), 0);
                  var statusCount_inActive = Belt_Option.getWithDefault(Json_decode.field("count", (function (param) {
                              return Json_decode.optional((function (param) {
                                            return Json_decode.field("false", Json_decode.$$int, param);
                                          }), param);
                            }), json), 0);
                  var statusCount = {
                    active: statusCount_active,
                    inActive: statusCount_inActive
                  };
                  Curry._1(setSearchKey, (function (param) {
                          return currentSearchKey;
                        }));
                  Curry._1(dispatch, {
                        TAG: "DisplayStatusCount",
                        _0: statusCount
                      });
                  return Promise.resolve();
                }), Http$ReactHooksTemplate.fetchGetJSON(url));
        }), [currentSearchKey]);
  React.useEffect((function (param) {
          Curry._1(dispatch, "LoadUsers");
          Js_promise.then_((function (param) {
                  var paginationInfo = param[1];
                  var perPage = paginationInfo[1];
                  var total = paginationInfo[0];
                  Curry._1(setPageInfo, (function (state) {
                          return {
                                  total: total,
                                  perPage: perPage,
                                  currentPage: state.currentPage
                                };
                        }));
                  return Js_promise.then_((function (xs) {
                                return Promise.resolve(Curry._1(dispatch, {
                                                TAG: "DisplayList",
                                                _0: xs
                                              }));
                              }), param[0]);
                }), fetchUsers());
        }), [
        currentPage,
        currentSearchKey
      ]);
  var handleCancelDelete = function (param) {
    Curry._1(setDeletingUser, (function (param) {
            return false;
          }));
    Curry._1(dispatch, "CancelDelete");
  };
  var data = function (statusCount) {
    return [
            {
              name: "active",
              count: statusCount.active
            },
            {
              name: "inactive",
              count: statusCount.inActive
            }
          ];
  };
  var opacityCss = match$2[0] ? "opacity-25" : "opacity-100";
  var summary = function (param) {
    return JsxRuntime.jsx("div", {
                children: state.loadingStatusCount ? JsxRuntime.jsx("p", {
                        children: "Loading data"
                      }) : JsxRuntime.jsx(Recharts.ResponsiveContainer, {
                        children: JsxRuntime.jsxs(Recharts.BarChart, {
                              data: data(state.statusCount),
                              margin: Caml_option.some(Recharts$ReactHooksTemplate.Margin.make(0, 0, 0, 40)),
                              layout: "vertical",
                              children: [
                                JsxRuntime.jsx(Recharts.XAxis, {
                                      dataKey: "count",
                                      type: "number"
                                    }),
                                JsxRuntime.jsx(Recharts.YAxis, {
                                      minTickGap: 1,
                                      dataKey: "name",
                                      interval: 0,
                                      tickFormatter: (function (key) {
                                          return key.toLocaleUpperCase();
                                        }),
                                      type: "category"
                                    }),
                                JsxRuntime.jsx(Recharts.Tooltip, {}),
                                JsxRuntime.jsx(Recharts.Bar, {
                                      dataKey: "count",
                                      barSize: 200,
                                      fill: "#ff7300"
                                    })
                              ]
                            })
                      }),
                className: "h-32 w-1/3 mb-4 bg-white rounded-sm shadow border-l-8 border-teal-600 mr-20-px p-8"
              });
  };
  var user = state.userToDelete;
  var tmp;
  if (user !== undefined) {
    var partial_arg = state.users;
    tmp = JsxRuntime.jsx(ConfirmationDialog$ReactHooksTemplate.make, {
          user: user,
          handleCancel: handleCancelDelete,
          handleDelete: (function (param) {
              Curry._1(setDeletingUser, (function (param) {
                      return true;
                    }));
              Js_promise.then_((function (param) {
                      return Promise.resolve((window.location.reload(), undefined));
                    }), Js_promise.then_((function (param) {
                          return Promise.resolve(Curry._1(dispatch, {
                                          TAG: "DisplayList",
                                          _0: partial_arg
                                        }));
                        }), deleteUser(user)));
            }),
          handleClose: handleCancelDelete
        });
  } else {
    tmp = null;
  }
  var tmp$1;
  tmp$1 = searchKey !== undefined && searchKey !== "" ? JsxRuntime.jsx("button", {
          children: JsxRuntime.jsx("span", {
                children: "✕",
                className: "text-sm"
              }),
          className: "absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 transition-colors duration-200",
          type: "button",
          onClick: (function (param) {
              Curry._1(setSearchKey, (function (param) {
                      
                    }));
              RescriptReactRouter.push("/users/all?page=1");
            })
        }) : null;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                tmp,
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsx("div", {
                                                          children: JsxRuntime.jsx("span", {
                                                                children: "👤",
                                                                className: "text-xl"
                                                              }),
                                                          className: "flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-blue-100 to-indigo-100 shadow-sm"
                                                        }),
                                                    JsxRuntime.jsxs("div", {
                                                          children: [
                                                            JsxRuntime.jsx("h1", {
                                                                  children: "Users",
                                                                  className: "text-2xl font-bold text-gray-900"
                                                                }),
                                                            JsxRuntime.jsx("p", {
                                                                  children: "Manage your users, roles and access permissions",
                                                                  className: "text-sm text-gray-600 mt-1"
                                                                })
                                                          ]
                                                        })
                                                  ],
                                                  className: "flex items-center space-x-3"
                                                }),
                                            Curry._1(hasPermission, "AddUser") ? JsxRuntime.jsxs("a", {
                                                    children: [
                                                      JsxRuntime.jsx("span", {
                                                            children: "+",
                                                            className: "mr-2"
                                                          }),
                                                      "Add New User"
                                                    ],
                                                    className: "inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200 shadow",
                                                    href: "/users/new"
                                                  }) : null
                                          ],
                                          className: "bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 px-6 py-6 border-b border-gray-200 flex items-center justify-between"
                                        }),
                                    JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsxs("form", {
                                                      children: [
                                                        JsxRuntime.jsx("div", {
                                                              children: JsxRuntime.jsx("span", {
                                                                    children: "🔍",
                                                                    className: "text-gray-400"
                                                                  }),
                                                              className: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                                                            }),
                                                        JsxRuntime.jsx("input", {
                                                              className: "w-full pl-10 pr-10 py-2.5 text-sm text-gray-900 placeholder-gray-400 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200",
                                                              placeholder: searchPlaceholder,
                                                              type: "text",
                                                              value: Belt_Option.getWithDefault(searchKey, ""),
                                                              onChange: (function ($$event) {
                                                                  var value = $$event.target.value;
                                                                  Curry._1(setSearchKey, (function (param) {
                                                                          if (value === "") {
                                                                            return ;
                                                                          } else {
                                                                            return value;
                                                                          }
                                                                        }));
                                                                })
                                                            }),
                                                        tmp$1
                                                      ],
                                                      className: "relative",
                                                      onSubmit: (function ($$event) {
                                                          $$event.preventDefault();
                                                          if (searchKey !== undefined) {
                                                            return RescriptReactRouter.push("/users/all?search=" + searchKey);
                                                          } else {
                                                            return RescriptReactRouter.push("/users/all?");
                                                          }
                                                        })
                                                    }),
                                                className: "flex-1 max-w-md"
                                              }),
                                          className: "bg-gray-50 border-b border-gray-200 px-6 py-4 flex items-center justify-between"
                                        }),
                                    JsxRuntime.jsx(Pagination$ReactHooksTemplate.Bar.make, {
                                          currentPage: currentPage,
                                          totalPages: totalPagesCount,
                                          totalRecords: totalCount,
                                          perPage: perPageCount,
                                          handlePageChange: handlePageChange,
                                          itemLabel: "users",
                                          className: "mx-6 mb-4"
                                        }),
                                    JsxRuntime.jsx("div", {
                                          children: state.loadingUsers ? JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsxs("div", {
                                                        children: [
                                                          JsxRuntime.jsx("div", {
                                                                className: "w-6 h-6 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"
                                                              }),
                                                          JsxRuntime.jsx("span", {
                                                                children: "Loading users...",
                                                                className: "text-gray-600"
                                                              })
                                                        ],
                                                        className: "flex items-center space-x-3"
                                                      }),
                                                  className: "flex items-center justify-center py-16"
                                                }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                                  children: [
                                                    summary(),
                                                    List.length(state.users) > 0 ? JsxRuntime.jsx("div", {
                                                            children: JsxRuntime.jsxs("table", {
                                                                  children: [
                                                                    JsxRuntime.jsx("thead", {
                                                                          children: JsxRuntime.jsxs("tr", {
                                                                                children: [
                                                                                  JsxRuntime.jsx("th", {
                                                                                        children: "Email",
                                                                                        className: "text-left py-3 px-4 font-medium text-gray-700"
                                                                                      }),
                                                                                  JsxRuntime.jsx("th", {
                                                                                        children: "Roles",
                                                                                        className: "text-left py-3 px-4 font-medium text-gray-700"
                                                                                      }),
                                                                                  JsxRuntime.jsx("th", {
                                                                                        children: "Last Sign In",
                                                                                        className: "text-left py-3 px-4 font-medium text-gray-700"
                                                                                      }),
                                                                                  JsxRuntime.jsx("th", {
                                                                                        children: "Status",
                                                                                        className: "text-left py-3 px-4 font-medium text-gray-700"
                                                                                      }),
                                                                                  JsxRuntime.jsx("th", {
                                                                                        children: "Data Restrictions",
                                                                                        className: "text-left py-3 px-4 font-medium text-gray-700"
                                                                                      }),
                                                                                  JsxRuntime.jsx("th", {
                                                                                        children: "",
                                                                                        className: "text-left py-3 px-4 font-medium text-gray-700"
                                                                                      })
                                                                                ]
                                                                              }),
                                                                          className: "bg-gray-50 border-b border-gray-200"
                                                                        }),
                                                                    JsxRuntime.jsx("tbody", {
                                                                          children: $$Array.of_list(List.map((function (user) {
                                                                                      return JsxRuntime.jsx(UserListItem$ReactHooksTemplate.make, {
                                                                                                  user: user,
                                                                                                  handleEdit: (function (param) {
                                                                                                      return RescriptReactRouter.push("/users/edit/" + String(User$ReactHooksTemplate.id(user)));
                                                                                                    }),
                                                                                                  handleDelete: (function (param) {
                                                                                                      Curry._1(setDeletingUser, (function (param) {
                                                                                                              return true;
                                                                                                            }));
                                                                                                      return Curry._1(dispatch, {
                                                                                                                  TAG: "DisplayDeleteConfirmation",
                                                                                                                  _0: user
                                                                                                                });
                                                                                                    })
                                                                                                }, String(User$ReactHooksTemplate.id(user)));
                                                                                    }), state.users)),
                                                                          className: "divide-y divide-gray-100"
                                                                        })
                                                                  ],
                                                                  className: "w-full text-sm"
                                                                }),
                                                            className: "overflow-x-auto rounded-lg border border-gray-200 shadow-sm mt-4"
                                                          }) : JsxRuntime.jsx("div", {
                                                            children: JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    JsxRuntime.jsx("div", {
                                                                          children: JsxRuntime.jsx("span", {
                                                                                children: "👥",
                                                                                className: "text-2xl text-gray-400"
                                                                              }),
                                                                          className: "w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center"
                                                                        }),
                                                                    JsxRuntime.jsx("h3", {
                                                                          children: "No users found",
                                                                          className: "text-lg font-medium text-gray-900"
                                                                        }),
                                                                    JsxRuntime.jsx("p", {
                                                                          children: "Add a user to get started",
                                                                          className: "text-sm text-gray-500"
                                                                        }),
                                                                    Curry._1(hasPermission, "AddUser") ? JsxRuntime.jsxs("a", {
                                                                            children: [
                                                                              JsxRuntime.jsx("span", {
                                                                                    children: "+",
                                                                                    className: "mr-2"
                                                                                  }),
                                                                              "Add Your First User"
                                                                            ],
                                                                            className: "inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200",
                                                                            href: "/users/new"
                                                                          }) : null
                                                                  ],
                                                                  className: "flex flex-col items-center space-y-4"
                                                                }),
                                                            className: "text-center py-12"
                                                          })
                                                  ]
                                                }),
                                          className: "px-6 py-6"
                                        })
                                  ],
                                  className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden mb-6 hover:shadow-xl transition-shadow duration-300"
                                }),
                            className: "mx-auto"
                          }),
                      className: "h-full bg-gray-50 min-h-screen px-6 sm:px-8 py-8 " + opacityCss
                    })
              ]
            });
}

var emptyPageInfo = {
  total: "1",
  perPage: "1",
  currentPage: 1
};

var make = UserList;

exports.deleteUser = deleteUser;
exports.reducer = reducer;
exports.emptyPageInfo = emptyPageInfo;
exports.totalRecord = totalRecord;
exports.perPage = perPage;
exports.initialState = initialState;
exports.searchPlaceholder = searchPlaceholder;
exports.make = make;
/* react Not a pure module */
